module.exports = __webpack_public_path__ + "img/about-pic-4.ccd1ff7f.jpg";